import React, { useState, useEffect } from 'react'
import { setHeader } from '@/util/set-header'
import { TextareaItem, Toast } from 'antd-mobile'
import './dismiss-opinion.less'
import { noticeChangeStatusApi } from '@/api/user-infomation'
import { getAuth } from '@/util/storage'
const auth = getAuth()
let customFocusInst: any
function DismissOpinion({ location }: any) {
  const [reason, setReasom]: any = useState()
  const handleChangeReason = (val: string | undefined) => {
    setReasom(val)
  }

  useEffect(() => {
    //驳回
    const submit = async () => {
      const { id, type } = location.state
      let formData = new FormData()
      formData.append('id', id)
      formData.append('type', type)
      formData.append('status', 'refused')
      formData.append('auth', auth)
      formData.append('reason', reason)
      Toast.loading('加载中', 0)
      const { data } = await noticeChangeStatusApi(formData)
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 2)
        return
      }
      Toast.info('已提交', 2, () => {
        if (window.WebViewBridge) {
          window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      })
    }
    setHeader({
      title: '驳回意见',
      right: (
        <span className="font-4" onClick={submit}>
          提交
        </span>
      ),
    })
  }, [location.state, reason])

  return (
    <div className="dismiss-opinion" onClick={() => customFocusInst.focus()}>
      <TextareaItem
        autoHeight
        placeholder="请输入驳回理由"
        ref={(el: any) => (customFocusInst = el)}
        onChange={handleChangeReason}
      />
    </div>
  )
}

export default DismissOpinion
